/*
 * File: c:\Users\j.mazat\Desktop\AutobuyBackOffice\AutobuyBackOffice\src\Content\Login\Login.tsx
 * Project: c:\Users\j.mazat\Desktop\AutobuyBackOffice\AutobuyBackOffice
 * Created Date: Wednesday June 7th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Friday, 23rd June 2023 03:12:52
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */
import { useLocation } from "react-router-dom";
import FormLogin from "./FormLogin/FormLogin";
import Styles from "Content/Login/Login.module.css";
import { useMemo } from "react";

function useQuery() {
    const { search } = useLocation();
    return useMemo(() => new URLSearchParams(search), [search]);
}

function Login() {
    const query = useQuery();

    return(
        <div className={`${Styles.login}`}>
            <FormLogin returnUrl={query.get("return_url")} />
        </div>
    );
}

export default Login;
